import { initAccordion } from './namespace/accordion';
import { initFloatButton } from './namespace/floatButton';

document.addEventListener('DOMContentLoaded', () => {
  initAccordion();
  initFloatButton();
});
